const departmentsAndMajors = {
    "College of Humanities, Education and Social Sciences": [
        "Africana Studies",
        "Global Studies",
        "Women's and Gender Studies",
        "Education",
        "Languages and Literatures",
        "History",
        "Political Science",
        "Philosophy",
        "Mass Communications",
        "Visual and Performing Arts",
        "Sociology",
        "Criminal Justice"
    ],
    "College of Business": [
        "Accounting",
        "Economics",
        "Finance",
        "Business Administration",
        "Aviation",
        "Sport Management"
    ],
    "College of Agriculture, Science and Technology": [
        "Agriculture & Natural Resources",
        "Biological Sciences",
        "Chemistry",
        "Human Ecology",
        "Physics",
        "Engineering",
        "Mathematics",
        "Computer Science"
    ],
    "Wesley College of Health and Behavioral Sciences": [
        "Nursing",
        "Psychology",
        "Social Work",
        "Public and Allied Health Sciences"
    ]
};

export default departmentsAndMajors;